import React from 'react';
import PropTypes from 'prop-types';

import styles from './DisplayIcon.scss';

const Icon = ({ src }) => (
  <i className={`${styles.DisplayIcon} ${styles[src]}`} />
);

Icon.propTypes = {
  src: PropTypes.string.isRequired
};

export default Icon;




// WEBPACK FOOTER //
// ./src/components/DisplayIcon/DisplayIcon.js